import { SET_AGENTSPORTFOLIO } from "./mutation-types";

const mutations = {
  [SET_AGENTSPORTFOLIO](state, agentsPortfolio) {
    state.agentsPortfolio = agentsPortfolio;
  },
};

export default mutations;
